const { keyMirror } = window.Edocat.Utils;

export default keyMirror([
    'PROMISE_UPDATE_CACHE',
]);
